<template>
  <div class="w-full">
    <h2 class="w-full mb-4 mr-4 text-red-400 text-center">Warning</h2>

    <p class="text-center">
      <span class="text-red-400 font-bold"
        >Your session will time out in less than 1 hour.</span
      >
      If you are in the middle of something quick, you may close this dialog and
      save your work.
    </p>
    <div
      class="flex flex-col space-y-4 mt-8 items-center justify-center w-full"
    >
      <button class="btn btn-trans-black m-0" @click="rejectIdleTimer">
        Finish what I'm doing
      </button>
      <button class="btn btn-primary m-0" @click="reload">
        Reload my session
      </button>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../js/plugins/event-bus.js'
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      dispatchSetIdleTimerClosed: 'shared/dispatchSetIdleTimerClosed',
    }),

    reload() {
      window.location.reload()
    },

    rejectIdleTimer() {
      this.dispatchSetIdleTimerClosed(true)
      EventBus.$emit('showModal', false)
    },
  },
}
</script>
